import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  jWrapper: {
    "& label[data-shrink=false] + .MuiInputBase-formControl .MuiInputBase-input::-webkit-input-placeholder":
      {
        opacity: "0.5 !important",
      },
    "& .MuiFormLabel-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.6)",
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.6)",
    },
    "& .MuiChip-root": {
      height: 18,
    },
    "& .MuiChip-deleteIcon": {
      width: 10,
      height: 10,
    },
    "& .MuiOutlinedInput-input, & .MuiOutlinedInput-multiline": {
      padding: "7px 8px",
    },
    "& input.Mui-disabled": {
      opacity: 0.7,
      backgroundColor: "#ddd",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "7px 20px 7px 8px",
      "&.Mui-disabled": {
        opacity: 0.7,
        backgroundColor: "#ddd",
      },
      "& .MuiAutocomplete-input": {
        padding: 0,
      },
      "&.MuiAutocomplete-clearIndicator": {
        padding: 4,
        marginRight: 0,
        height: 15,
        width: 15,
        position: "relative",
        top: 5,
      },
    },
    "& .MuiInputLabel-formControl": {
      position: "relative",
      transform: "none !important",
      marginBottom: 8,
      fontSize: 14,
    },
    "& legend.PrivateNotchedOutline-legendNotched-4": {
      maxWidth: 0,
    },
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: 4,
    },
    "& .MuiInputAdornment-positionEnd": {
      width: 21,
    },
    "& .react-datepicker__close-icon": {
      padding: 0,
      right: 3,
      top: "auto",
      bottom: 7,
      height: 20,
    },
    "& .MuiAccordionSummary-root": {
      backgroundColor: "#eaeaea",
      borderRadius: 5,
      flexDirection: "row-reverse",
    },
    "& .MuiAccordionDetails-root, & .MuiAccordionSummary-root": {
      padding: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded, & .MuiAccordionSummary-content":
      {
        margin: 0,
      },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      minHeight: 50,
    },
    "& .MuiAccordion-root:before": {
      backgroundColor: "transparent",
    },
  },

  infoHeader: {
    display: "flex",
    alignItems: "center",
    minHeight: 36,
    "& h3": {
      margin: "0 8px",
    },
  },

  tableClickableDiv: {
    minHeight: 50,
    width: "100%",
    alignItems: "center",
    display: "flex",
  },
  form: {
    flex: 1,
  },
  formSectionHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 15,
    backgroundColor: "#eaeaea",
    borderRadius: 5,
    padding: "0 20px",
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row",
    marginLeft: -15,
    marginRight: -15,
    marginBottom: 10,
    marginTop: 10,
  },
  fieldsCol: {
    flex: 1,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 4,
  },
  paperForm: {
    width: "100%",
  },
  paperFormHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 15px",
    borderBottom: "1px solid #dddddd",
  },
  paperFormBody: {
    padding: 15,
  },
  jLayoutCustom: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
    "& > div:first-child": {
      flex: 0,
      marginTop: 5,
      width: "calc(100% - 16px)",
    },
  },
  jBeforePaper: {
    // flex: 1,
    // padding: "16px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: 12,
    paddingBottom: 12,
    borderBottom: "1px solid #ddd",
    "& h3": {
      marginLeft: "10px",
    },
    "& > div:first-child": {
      display: "flex",
      alignItems: "center",
    },
    "& div:last-child": {},
    "& .MuiFormControl-root": {
      // backgroundColor: "transparent",
      "& .MuiOutlinedInput-root": {
        minHeight: 38,
      },
    },
    "& button": {
      marginRight: 10,
    },
  },

  jBeforePaper_filter: {
    display: "flex",
    position: "relative",
    zIndex: 100,
    '& .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"], & .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]':
      {
        height: 37,
      },
  },
  scrollTable: {
    marginBottom: 16,
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
      padding: 0,
      maxHeight: "var(--fourtyVh)",
      overflowY: "auto",
    },
    "& td.MuiTableCell-body:first-child": {
      position: "sticky",
      left: 0,
      backgroundColor: "white",
    },
    "& tr:hover td.MuiTableCell-body:first-child": {
      backgroundColor: theme.color.gray1,
    },
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
    "& thead": {
      position: "sticky",
      top: 0,
      zIndex: 1,
      "& th.MuiTableCell-head:first-child": {
        position: "sticky",
        left: 0,
        backgroundColor: theme.color.gray1,
        zIndex: 1,
      },
    },
  },
  scrollTableXL: {
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
      padding: 0,
      maxHeight: "var(--seventyFiveVh)",
      overflowY: "auto",
    },
  },
  jPaper: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderColor: "white",
    borderStyle: "solid",
    borderWidth: 12,
    overflowY: "auto",
    flex: 1,
    marginBottom: 24,
    "& td.MuiTableCell-body:first-child": {
      position: "sticky",
      left: 0,
      backgroundColor: "white",
    },
    "& tr:hover td.MuiTableCell-body:first-child": {
      backgroundColor: theme.color.gray1,
    },
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
      padding: 0,
      display: "flex",
      alignItems: "flex-start",
      minHeight: "auto", // before : 350 in order to prevent calendar to be cut
    },
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
    "& thead": {
      position: "sticky",
      top: 0,
      zIndex: 2,
      "& th.MuiTableCell-head:first-child": {
        position: "sticky",
        left: 0,
        backgroundColor: theme.color.gray1,
        zIndex: 1000,
      },
    },
  },
  jTopHead: {
    width: "100%",
    minWidth: "fit-content",
    backgroundColor: `${theme.color.gray1} !important`,
    '& div[class*="select-"]': {
      backgroundColor: `${theme.color.gray1} !important`,
    },
    "& label.MuiFormLabel-root": {
      color: theme.color.gray5,
      fontSize: 13,
      minHeight: 24,
      fontFamily: "Work Sans, sans-serif",
      fontWeight: 500,
      lineHeight: "16px",
      marginBottom: 0,
    },
  },
  jTopheadLabel: {
    minHeight: 24,
    display: "flex",
  },
  jTopheadLabelEDB: {
    minHeight: 32,
    display: "flex",
    marginBottom: 0,
    lineHeight: "16px",
    alignItems: "center",
  },
  jTableLabelHeader: {
    "& .MuiInputLabel-formControl": {
      fontFamily: "Work Sans, sans-serif",
      lineHeight: "16px",
      color: theme.color.gray5,
      fontSize: 13,
      minHeight: "24px",
      marginBottom: 0,
      fontWeight: 500,
    },
  },
  jLoadingTable: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  jNoResultPlaceHolder: {
    backgroundColor: "rgba(255,255,255,0.9)",
    position: "absolute",
    top: 0,
    left: 0,
    minHeight: "420px",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& h3": {
      position: "relative",
      // top: '-130px',
    },
  },
  jBtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: 300, // todo
      background: "white",
    },
  },
  jAddCta: {
    marginRight: "10px !important",
    marginLeft: 8,
  },
  jAddCta2: {
    marginLeft: "10px !important",
  },
  jEllipsedText: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
    maxWidth: "100%",
  },
  jBreakWordText: {
    whiteSpace: "normal",
    overflowWrap: "break-word",
    overflow: "hidden",
    display: "block",
    maxWidth: "100%",
  },
  jDialogContent: {
    textAlign: "center",
  },
  ghostLink: {
    textDecoration: "none",
    color: "inherit",
  },
  optionsGap: {
    gap: theme.spacing(1),
  },
  optionsDetails: {
    color: theme.color.gray5,
    fontSize: "1em",
  },
  bataillogDatepicker: {
    position: "absolute",
    zIndex: 10000,
    top: "0%",
    left: "calc(100% - 70px)",
  },
}));

const useJStyles: any = () => {
  const jclasses = useStyles();
  return { jclasses };
};

export default useJStyles;
